import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { InstaLearnTopic } from '../../../common/models';
import { SwiperComponent } from '../../../common/components';
import { ColorHelperService } from '../../../common/services';



@Component({
    selector: 'lib-insta-learn-topics-widget',
    templateUrl: './insta-learn-topics-widget.component.html',
    styleUrls: ['./insta-learn-topics-widget.component.scss'],
    standalone: false
})
export class InstaLearnTopicsWidgetComponent {
  @ViewChild(SwiperComponent) public swiperComponent: SwiperComponent;

  @Input() public title: string;
  @Input() public textColor: string;
  @Input() public set highlightColor(value: string) {
    this._highlightColor = value;
    this._highlightTextColor = value ? this.colorHelperSerivce.getContrastingTextColor(value) : null;

    this.applyHighlightColors();
  }

  @Input() public items: InstaLearnTopic[] = [];

  @Input() public animation: string;
  @Input() public animationDelay = 0;

  @Output() public openTopic: EventEmitter<InstaLearnTopic> = new EventEmitter();

  private _highlightColor: string | null = null;
  private _highlightTextColor: string | null = null;

  public swiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    slidesPerGroup: 2,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      768: {
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      1024: {
        spaceBetween: 24
      }
    }
  }

  constructor(
    private readonly element: ElementRef,
    private readonly colorHelperSerivce: ColorHelperService) { }


  private applyHighlightColors(): void {
    const style = this.element.nativeElement.style;

    if (this._highlightColor) {
      style.setProperty('--lms-topic-widget-highlight-color', this._highlightColor);
    } else {
      style.removeProperty('--lms-topic-widget-highlight-color');
    }

    if (this._highlightTextColor) {
      style.setProperty('--lms-topic-widget-highlight-text-color', this._highlightTextColor);
    } else {
      style.removeProperty('--lms-topic-widget-highlight-text-color');
    }
  }
}
